export const SWEEP_DUMMY_TOKEN = 'SWEEP_DUMMY_TOKEN';
